import { API_ENDPOINT } from "../constants"
import { HTTP } from "./http"

export const DBClientsService ={
    
    save: (data: FormData) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}base-clients/v4.0/upload-base`, data);
    },
    handleStatusDB: (data: any) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}base-clients/changeStatusDb`, data);
    },
    getAll: (account_id: number, init: string, end: string) => {
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}base-clients/v4.0/get-bases/${account_id}`, { params: { init, end } });
    },
    downloadReport: (id_base_clients: number) => {
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}base-clients/downloadDb`, { params: { id_base_clients } });
    },
}
